var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-button',_vm._b({class:_vm.prefixCls,attrs:{"size":_vm.size,"type":_vm.buttonType},on:{"click":_vm.toggleSelect}},'d-button',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }